export const titleOptions = [
  '-',
  'Mr',
  'Mrs',
  'Miss',
  'Ms',
  'Dr',
  'Prof',
  'Other',
].map((option) => ({ key: option, value: option }));

export const countryOptions = [
  {
    key: 'Afghanistan',
    value: 'AF',
  },
  {
    key: 'Albania',
    value: 'AL',
  },
  {
    key: 'Algeria',
    value: 'DZ',
  },
  {
    key: 'American Samoa',
    value: 'AS',
  },
  {
    key: 'Andorra',
    value: 'AD',
  },
  {
    key: 'Angola',
    value: 'AO',
  },
  {
    key: 'Anguilla',
    value: 'AI',
  },
  {
    key: 'Argentina',
    value: 'AR',
  },
  {
    key: 'Armenia',
    value: 'AM',
  },
  {
    key: 'Aruba',
    value: 'AW',
  },
  {
    key: 'Australia',
    value: 'AU',
  },
  {
    key: 'Azerbaijan',
    value: 'AZ',
  },
  {
    key: 'Bahamas',
    value: 'BS',
  },
  {
    key: 'Bahrain',
    value: 'BH',
  },
  {
    key: 'Bangladesh',
    value: 'BD',
  },
  {
    key: 'Barbados',
    value: 'BB',
  },
  {
    key: 'Belarus',
    value: 'BY',
  },
  {
    key: 'Belgium',
    value: 'BE',
  },
  {
    key: 'Belize',
    value: 'BZ',
  },
  {
    key: 'Benin',
    value: 'BJ',
  },
  {
    key: 'Bermuda',
    value: 'BM',
  },
  {
    key: 'Bhutan',
    value: 'BT',
  },
  {
    key: 'Bolivia',
    value: 'BO',
  },
  {
    key: 'Bosnia and Herzegovina',
    value: 'BA',
  },
  {
    key: 'Botswana',
    value: 'BW',
  },
  {
    key: 'Brazil',
    value: 'BR',
  },
  {
    key: 'British Virgin Islands',
    value: 'VG',
  },
  {
    key: 'Brunei',
    value: 'BN',
  },
  {
    key: 'Bulgaria',
    value: 'BG',
  },
  {
    key: 'Burkina Faso',
    value: 'BF',
  },
  {
    key: 'Burundi',
    value: 'BI',
  },
  {
    key: 'Cambodia',
    value: 'KH',
  },
  {
    key: 'Cameroon',
    value: 'CM',
  },
  {
    key: 'Canada',
    value: 'CA',
  },
  {
    key: 'Cape Verde',
    value: 'CV',
  },
  {
    key: 'Cayman Islands',
    value: 'KY',
  },
  {
    key: 'Central African Republic',
    value: 'CF',
  },
  {
    key: 'Chad',
    value: 'TD',
  },
  {
    key: 'Chile',
    value: 'CL',
  },
  {
    key: 'China',
    value: 'CN',
  },
  {
    key: 'Columbia',
    value: 'CO',
  },
  {
    key: 'Comoros',
    value: 'KM',
  },
  {
    key: 'Cook Islands',
    value: 'CK',
  },
  {
    key: 'Costa Rica',
    value: 'CR',
  },
  {
    key: 'Croatia',
    value: 'HR',
  },
  {
    key: 'Cuba',
    value: 'CU',
  },
  {
    key: 'Curacao',
    value: 'CW',
  },
  {
    key: 'Cyprus',
    value: 'CY',
  },
  {
    key: 'Czech Republic',
    value: 'CZ',
  },
  {
    key: 'Democratic Republic of the Congo',
    value: 'CD',
  },
  {
    key: 'Denmark',
    value: 'DK',
  },
  {
    key: 'Djibouti',
    value: 'DJ',
  },
  {
    key: 'Dominica',
    value: 'DM',
  },
  {
    key: 'Dominican Republic',
    value: 'DO',
  },
  {
    key: 'East Timor',
    value: 'TL',
  },
  {
    key: 'Ecuador',
    value: 'EC',
  },
  {
    key: 'Egypt',
    value: 'EG',
  },
  {
    key: 'El Salvador',
    value: 'SV',
  },
  {
    key: 'Eritrea',
    value: 'ER',
  },
  {
    key: 'Estonia',
    value: 'EE',
  },
  {
    key: 'Ethiopia',
    value: 'ET',
  },
  {
    key: 'Faroe Islands',
    value: 'FO',
  },
  {
    key: 'Fiji',
    value: 'FJ',
  },
  {
    key: 'Finland',
    value: 'FI',
  },
  {
    key: 'France',
    value: 'FR',
  },
  {
    key: 'French Polynesia',
    value: 'PF',
  },
  {
    key: 'Gabon',
    value: 'GA',
  },
  {
    key: 'Gambia',
    value: 'GM',
  },
  {
    key: 'Georgia',
    value: 'GE',
  },
  {
    key: 'Germany',
    value: 'DE',
  },
  {
    key: 'Ghana',
    value: 'GH',
  },
  {
    key: 'Greece',
    value: 'GR',
  },
  {
    key: 'Greenland',
    value: 'GL',
  },
  {
    key: 'Grenada',
    value: 'GD',
  },
  {
    key: 'Guam',
    value: 'GU',
  },
  {
    key: 'Guatemala',
    value: 'GT',
  },
  {
    key: 'Guernsey',
    value: 'GG',
  },
  {
    key: 'Guinea',
    value: 'GN',
  },
  {
    key: 'Guinea-Bissau',
    value: 'GW',
  },
  {
    key: 'Guyana',
    value: 'GY',
  },
  {
    key: 'Haiti',
    value: 'HT',
  },
  {
    key: 'Honduras',
    value: 'HN',
  },
  {
    key: 'Hong Kong',
    value: 'HK',
  },
  {
    key: 'Hungary',
    value: 'HU',
  },
  {
    key: 'Iceland',
    value: 'IS',
  },
  {
    key: 'India',
    value: 'IN',
  },
  {
    key: 'Indonesia',
    value: 'ID',
  },
  {
    key: 'Iran',
    value: 'IR',
  },
  {
    key: 'Iraq',
    value: 'IQ',
  },
  {
    key: 'Ireland',
    value: 'IE',
  },
  {
    key: 'Isle of Man',
    value: 'IM',
  },
  {
    key: 'Israel',
    value: 'IL',
  },
  {
    key: 'Italy',
    value: 'IT',
  },
  {
    key: 'Ivory Coast',
    value: 'CI',
  },
  {
    key: 'Jamaica',
    value: 'JM',
  },
  {
    key: 'Japan',
    value: 'JP',
  },
  {
    key: 'Jersey',
    value: 'JE',
  },
  {
    key: 'Jordan',
    value: 'JO',
  },
  {
    key: 'Kazakhstan',
    value: 'KZ',
  },
  {
    key: 'Kenya',
    value: 'KE',
  },
  {
    key: 'Kiribati',
    value: 'KI',
  },
  {
    key: 'Kosovo',
    value: 'XK',
  },
  {
    key: 'Kuwait',
    value: 'KW',
  },
  {
    key: 'Kyrgyzstan',
    value: 'KG',
  },
  {
    key: 'Laos',
    value: 'LA',
  },
  {
    key: 'Latvia',
    value: 'LV',
  },
  {
    key: 'Lebanon',
    value: 'LB',
  },
  {
    key: 'Lesotho',
    value: 'LS',
  },
  {
    key: 'Liberia',
    value: 'LB',
  },
  {
    key: 'Libya',
    value: 'LY',
  },
  {
    key: 'Liechtenstein',
    value: 'LI',
  },
  {
    key: 'Lithuania',
    value: 'LT',
  },
  {
    key: 'Luxembourg',
    value: 'LU',
  },
  {
    key: 'Macau',
    value: 'MO',
  },
  {
    key: 'Macedonia',
    value: 'MK',
  },
  {
    key: 'Madagascar',
    value: 'MG',
  },
  {
    key: 'Malawi',
    value: 'MW',
  },
  {
    key: 'Malaysia',
    value: 'MY',
  },
  {
    key: 'Maldives',
    value: 'MV',
  },
  {
    key: 'Mali',
    value: 'ML',
  },
  {
    key: 'Malta',
    value: 'MT',
  },
  {
    key: 'Marshall Islands',
    value: 'MH',
  },
  {
    key: 'Mauritania',
    value: 'MR',
  },
  {
    key: 'Mauritius',
    value: 'MU',
  },
  {
    key: 'Mayotte',
    value: 'YT',
  },
  {
    key: 'Mexico',
    value: 'MX',
  },
  {
    key: 'Micronesia',
    value: 'FM',
  },
  {
    key: 'Moldova',
    value: 'MD',
  },
  {
    key: 'Monaco',
    value: 'MC',
  },
  {
    key: 'Mongolia',
    value: 'MN',
  },
  {
    key: 'Montenegro',
    value: 'ME',
  },
  {
    key: 'Morocco',
    value: 'MA',
  },
  {
    key: 'Mozambique',
    value: 'MZ',
  },
  {
    key: 'Myanmar',
    value: 'MM',
  },
  {
    key: 'Namibia',
    value: 'NA',
  },
  {
    key: 'Nepal',
    value: 'NP',
  },
  {
    key: 'Netherlands',
    value: 'NL',
  },
  {
    key: 'Netherlands Antilles',
    value: 'AN',
  },
  {
    key: 'New Caledonia',
    value: 'NC',
  },
  {
    key: 'New Zealand',
    value: 'NZ',
  },
  {
    key: 'Nicaragua',
    value: 'NI',
  },
  {
    key: 'Niger',
    value: 'NE',
  },
  {
    key: 'Nigeria',
    value: 'NG',
  },
  {
    key: 'North Korea',
    value: 'KP',
  },
  {
    key: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    key: 'Norway',
    value: 'NO',
  },
  {
    key: 'Oman',
    value: 'OM',
  },
  {
    key: 'Pakistan',
    value: 'PK',
  },
  {
    key: 'Palestine',
    value: 'PS',
  },
  {
    key: 'Panama',
    value: 'PA',
  },
  {
    key: 'Papua New Guinea',
    value: 'PG',
  },
  {
    key: 'Paraguay',
    value: 'PY',
  },
  {
    key: 'Peru',
    value: 'PE',
  },
  {
    key: 'Philippines',
    value: 'PH',
  },
  {
    key: 'Poland',
    value: 'PL',
  },
  {
    key: 'Portugal',
    value: 'PT',
  },
  {
    key: 'Puerto Rico',
    value: 'PR',
  },
  {
    key: 'Qatar',
    value: 'QA',
  },
  {
    key: 'Republic of the Congo',
    value: 'CG',
  },
  {
    key: 'Reunion',
    value: 'RE',
  },
  {
    key: 'Romania',
    value: 'RO',
  },
  {
    key: 'Russia',
    value: 'RU',
  },
  {
    key: 'Rwanda',
    value: 'RW',
  },
  {
    key: 'Saint Kitts and Nevis',
    value: 'KN',
  },
  {
    key: 'Saint Lucia',
    value: 'LC',
  },
  {
    key: 'Saint Martin',
    value: 'MF',
  },
  {
    key: 'Saint Pierre and Miquelon',
    value: 'PM',
  },
  {
    key: 'Saint Vincent and the Grenadines',
    value: 'VC',
  },
  {
    key: 'Samoa',
    value: 'WS',
  },
  {
    key: 'San Marino',
    value: 'SM',
  },
  {
    key: 'Sao Tome and Principe',
    value: 'ST',
  },
  {
    key: 'Saudi Arabia',
    value: 'SA',
  },
  {
    key: 'Senegal',
    value: 'SN',
  },
  {
    key: 'Serbia',
    value: 'RS',
  },
  {
    key: 'Seychelles',
    value: 'SC',
  },
  {
    key: 'Sierra Leone',
    value: 'SL',
  },
  {
    key: 'Singapore',
    value: 'SG',
  },
  {
    key: 'Sint Maarten',
    value: 'SX',
  },
  {
    key: 'Slovakia',
    value: 'SK',
  },
  {
    key: 'Slovenia',
    value: 'SI',
  },
  {
    key: 'Solomon Islands',
    value: 'SB',
  },
  {
    key: 'Somalia',
    value: 'SO',
  },
  {
    key: 'South Africa',
    value: 'ZA',
  },
  {
    key: 'South Korea',
    value: 'KR',
  },
  {
    key: 'South Sudan',
    value: 'SS',
  },
  {
    key: 'Spain',
    value: 'ES',
  },
  {
    key: 'Sri Lanka',
    value: 'LK',
  },
  {
    key: 'Sudan',
    value: 'SD',
  },
  {
    key: 'Suriname',
    value: 'SR',
  },
  {
    key: 'Swaziland',
    value: 'SZ',
  },
  {
    key: 'Sweden',
    value: 'SE',
  },
  {
    key: 'Switzerland',
    value: 'CH',
  },
  {
    key: 'Syria',
    value: 'SY',
  },
  {
    key: 'Taiwan',
    value: 'TW',
  },
  {
    key: 'Tajikistan',
    value: 'TJ',
  },
  {
    key: 'Tanzania',
    value: 'TZ',
  },
  {
    key: 'Thailand',
    value: 'TH',
  },
  {
    key: 'Togo',
    value: 'TG',
  },
  {
    key: 'Tonga',
    value: 'TO',
  },
  {
    key: 'Trinidad and Tobago',
    value: 'TT',
  },
  {
    key: 'Tunisia',
    value: 'TN',
  },
  {
    key: 'Turkey',
    value: 'TR',
  },
  {
    key: 'Turkmenistan',
    value: 'TM',
  },
  {
    key: 'Turks and Caicos Islands',
    value: 'TC',
  },
  {
    key: 'Tuvalu',
    value: 'TV',
  },
  {
    key: 'U.S. Virgin Islands',
    value: 'VI',
  },
  {
    key: 'Uganda',
    value: 'UG',
  },
  {
    key: 'Ukraine',
    value: 'UA',
  },
  {
    key: 'United Arab Emirates',
    value: 'AE',
  },
  {
    key: 'United Kingdom',
    value: 'GB',
  },
  {
    key: 'United States',
    value: 'US',
  },
  {
    key: 'Uruguay',
    value: 'UY',
  },
  {
    key: 'Uzbekistan',
    value: 'UZ',
  },
  {
    key: 'Vanuatu',
    value: 'VU',
  },
  {
    key: 'Venezuela',
    value: 'VE',
  },
  {
    key: 'Vietnam',
    value: 'VN',
  },
  {
    key: 'Western Sahara',
    value: 'EH',
  },
  {
    key: 'Yemen',
    value: 'YE',
  },
  {
    key: 'Zambia',
    value: 'ZM',
  },
  {
    key: 'Zimbabwe',
    value: 'ZW',
  },
];
